export default {"src":"__ASTRO_ASSET_IMAGE__00N4M0CK__","width":858,"height":711,"format":"jpg"}